import type { ComponentType, ReactNode, SVGProps } from "react";
import { cn } from "../../lib/utils";

export interface EmptyStateProps {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  title: ReactNode;
  description?: ReactNode;
  /** A Button, usually. */
  action?: ReactNode;
  compact?: boolean;
  className?: string;
}

/** Centered empty panel: icon tile, title, one-line reason, optional action. */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  compact = false,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center px-4 text-center",
        compact ? "gap-3 py-6" : "gap-4 py-10",
        className
      )}
    >
      <div
        className={cn(
          "flex items-center justify-center rounded-3xl border border-black/[0.06] bg-canvas-subtle text-ink-muted/50 shadow-inner",
          compact ? "size-16" : "size-24"
        )}
      >
        <Icon aria-hidden="true" className={compact ? "size-8" : "size-12"} />
      </div>
      <div className="flex flex-col gap-1">
        <p className="text-sm font-bold text-ink">{title}</p>
        {description && (
          <p className="mx-auto max-w-[260px] text-xs text-ink-muted">
            {description}
          </p>
        )}
      </div>
      {action}
    </div>
  );
}
